import { render, staticRenderFns } from "./customer-manage.vue?vue&type=template&id=2ac1d258&scoped=true&"
import script from "./customer-manage.vue?vue&type=script&lang=js&"
export * from "./customer-manage.vue?vue&type=script&lang=js&"
import style0 from "./customer-manage.vue?vue&type=style&index=0&id=2ac1d258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac1d258",
  null
  
)

export default component.exports